<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 基础信息
        </el-breadcrumb-item>
        <el-breadcrumb-item>工单扩展属性</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工单编码" prop="orderno">
                <el-input v-model.trim="searchform.orderno" style="width:100%" clearable disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="product_code">
                <el-input
                  v-model.trim="searchform.product_code"
                  style="width:100%"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" @click="add.addshow=!add.addshow , update.show = false">新增</el-button>
        <el-button
          :loading="downloadLoading"
          type="primary"
          icon="document"
          @click="handleDownload"
        >导出Excel</el-button>
      </div>
      <br id="A1" />
      <!-- 新增修改模块       -->
      <Extend-Add :add="add" :search="search" />
      <Extend-Update ref="mychild" :update="update" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>工单扩展属性</h4>
          <el-divider />
          <el-table
            id="parent"
            v-loading="listLoading"
            border
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
          >
            <el-table-column prop="sort" label="排序" min-width="100" show-overflow-tooltip />
            <el-table-column prop="column_title" label="标题" min-width="100" show-overflow-tooltip />
            <el-table-column prop="column_value" label="说明" min-width="80" show-overflow-tooltip />
            <el-table-column prop="sortname" label="状态" min-width="80" show-overflow-tooltip />
            <el-table-column prop="product_code" label="供应商" min-width="120" show-overflow-tooltip />
            <el-table-column prop="create_time" label="创建时间" min-width="120" show-overflow-tooltip />
            <el-table-column label="操作" min-width="100" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="getoutbilldata(props.row),update.show =true , add.addshow=false"
                  />
                  <el-button type="danger" icon="el-icon-delete" @click="deletedate(props.row.id)" />
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            :current-page.sync="total_pages"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
            @current-change="currentchange"
            @size-change="pagesize"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  workordextendlist,
  workordextenddetails,
  workordextenddel
} from "@/api/plant";
import ExtendAdd from "./components/ExtendAdd";
import ExtendUpdate from "./components/ExtendUpdate";
// 引入导出组件模块
export default {
  name: "Orderextendlist",
  components: { ExtendAdd, ExtendUpdate },
  data() {
    return {
      // 基础数据
      add: {
        addshow: false,
        form: {
          orderno: this.$route.query.orderno,
          workorder_senior_id: this.$route.query.id,
          product_code: this.$route.query.product_code,
          column_title: null,
          column_value: null,
          status: 0,
          sort: 0
        }
      },
      update: {
        form: {
          workorder_senior_id: this.$route.query.id,
          column_title: null,
          column_value: null,
          status: 0,
          sort: 0
        },
        show: false
      },
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      // 分页数据
      pagesizes: "",
      total_count: 1,
      total_pages: 1,
      // 搜索表单数据

      searchform: {
        workorder_senior_id: this.$route.query.id,
        orderno: this.$route.query.orderno,
        // batchno: this.$route.query.batchno,
        product_code: this.$route.query.product_code,
        pageindex: 1,
        pagesize: 10
      }
    };
  },
  mounted() {
    // 请求部门列表数据并且便利到表格
    this.search();
  },
  methods: {
    // 下载出库单
    getoutbilldata(row) {
      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      this.update.form = row;
    },
    // 请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      workordextendlist(obj).then(response => {
        console.log(response.data);
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.total_count = response.data.total_count;
        this.total_pages = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].sort) {
          case 0:
            obj[i].sortname = "显示";
            break;
          case 1:
            obj[i].sortname = "不显示";
            break;
          default:
            break;
        }
      }
    },
    // 搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 分页跳转事件
    currentchange(pageindex) {
      this.searchform.pageindex = pageindex;
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        product_code: this.searchform.product_code,
        pageindex: this.searchform.pageindex,
        pagesize: this.searchform.pagesize
      });
    },
    // 分页每页显示条数事件
    pagesize(pagesize) {
      this.searchform.pagesize = pagesize;
      this.search();
    },
    // 删除按钮事件
    deletedate(id) {
      console.log(id);
      this.$confirm("此操作将永久删除该扩展属性信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          workordextenddel({
            id: id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        pageindex: 1,
        pagesize: this.total_count
      };
      workordextendlist(obj).then(response => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["工单编码", "批次", "供应商"];
          const filterVal = ["orderno", "batchno", "product_code"];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    // 跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>
